import { render } from "./BusinessModule.vue?vue&type=template&id=56aa5456&scoped=true"
import script from "./BusinessModule.vue?vue&type=script&lang=js"
export * from "./BusinessModule.vue?vue&type=script&lang=js"

import "@/assets/styles/businessmodule.css?vue&type=style&index=0&id=56aa5456&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56aa5456"]])

export default __exports__